import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { ButtonReset } from '@helpers/global';
import { Device, from } from '@helpers/media';
import { paragraphSmall } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.section `
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  @media ${from(Device.TabletLarge)} {
    gap: 6px;
  }

  [data-variant='light'] & {
    --pillBgColour: ${brand.white};
    --hoverpillBgColour: ${brand.primary.purple};
    --pillColour: ${brand.primary.purple};
    --pillHoverColour: ${brand.primary.offWhite};
  }

  [data-variant='dark'] & {
    --pillBgColour: ${brand.primary.offWhite};
    --hoverpillBgColour: ${brand.secondary.red};
    --pillColour: ${brand.primary.purple};
    --pillHoverColour: ${brand.primary.purple};
  }
`;
const Pill = styled.button `
  --pillColour: ${(props) => props.pillColour?.fg};
  --pillHoverColour: ${(props) => props.pillColour?.fg};
  --pillBgColour: ${(props) => props.pillColour?.bg};
  --hoverpillBgColour: ${(props) => props.pillColour?.bg};

  ${ButtonReset}
  ${transition('background-size, color')};
  ${paragraphSmall};

  color: var(--pillColour);
  text-decoration: none;
  display: block;
  margin: 0;
  background: var(--pillBgColour);
  background-image: linear-gradient(to right, var(--hoverpillBgColour), var(--hoverpillBgColour));
  background-repeat: no-repeat;
  background-size: 0% 100%;
  border-radius: 5000px;
  padding: 4px ${fluid(16, 20)} 5px;

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-style: solid;
    outline-width: 2px;
  }

  &.focus-ring,
  &[data-active='true'],
  &:hover {
    color: var(--pillHoverColour);
    background-size: 100% 100%;
  }
`;
const CategoryPillsStyles = {
    Container,
    Pill,
};
export default CategoryPillsStyles;
